import { useCallback, useEffect, useRef, useState } from "react";
import api from "@/lib/api";

// Per-user UI preferences (column order / widths / sort), cached locally and
// persisted to /api/ui-prefs/{key}.
export function useUiPref(key, fallback) {
  const lsKey = `strata:pref:${key}`;
  const [value, setValue] = useState(() => {
    try { const v = localStorage.getItem(lsKey); return v ? { ...fallback, ...JSON.parse(v) } : fallback; } catch { return fallback; }
  });
  const timer = useRef(null);

  useEffect(() => {
    let cancelled = false;
    api.get(`/ui-prefs/${key}`).then(({ data }) => {
      if (!cancelled && data?.value) setValue((v) => ({ ...v, ...data.value }));
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [key]);

  const update = useCallback((patch) => {
    setValue((prev) => {
      const next = { ...prev, ...(typeof patch === "function" ? patch(prev) : patch) };
      try { localStorage.setItem(lsKey, JSON.stringify(next)); } catch {}
      clearTimeout(timer.current);
      timer.current = setTimeout(() => api.put(`/ui-prefs/${key}`, { value: next }).catch(() => {}), 600);
      return next;
    });
  }, [key, lsKey]);

  return [value, update];
}
